import { useState } from "react";
import { t } from "../i18n";
import { CheckIcon, CopyIcon } from "./icons";

/** A command or URL in a code block with a copy button.
 *  `inline` - the mockup's form: a box as wide as its text and a ghost «Copy» text button beside it. */
export function CopyBlock({ text, inline = false }: { text: string; inline?: boolean }) {
  const [copied, setCopied] = useState(false);
  async function copy() {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      /* clipboard unavailable: the text stays selectable */
    }
  }
  if (inline)
    return (
      <div className="copy-inline">
        <code>{text}</code>
        <button type="button" className="btn btn-ghost" onClick={() => void copy()}>
          {copied ? t("common.copied") : t("common.copy")}
        </button>
      </div>
    );
  return (
    <div className="copy-row">
      <pre>{text}</pre>
      <button type="button" className="btn btn-ghost" onClick={() => void copy()}>
        {copied ? <CheckIcon /> : <CopyIcon />}
        {copied ? t("common.copied") : t("common.copy")}
      </button>
    </div>
  );
}
